import { createEditor } from "./edit/mapEdit"
import { MapLayerOpacityCtrl } from "./layer-opacity/layer-opacity"
import { LocationCtrl } from "./location/location"
import { MapMeasuringService } from "./measuring/svc"
import { MapOptionsCtrl } from "./options/options"
import { JstsTopologyService } from "./topo/jsts"
import { createMapView } from "./view/mapView"

export function setupMap(module: ng.IModule) {

    module

        .service("OmniaMapTopologyService", JstsTopologyService)

        .service("OmniaMapMeasuringService", MapMeasuringService)

        .directive("omniaMapView", createMapView)
        .directive("omniaMapEdit", createEditor)

        .directive("omniaMapLayersPopup", MapOptionsCtrl.create)
        .directive("omniaMapLocation", LocationCtrl.create)

        .directive("omniaMapLayerOpacity", MapLayerOpacityCtrl.create)


};
